"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diasUteisParaAssinaturaContratoGeracaoDistribuida = exports.diasUteisParaAssinatura = exports.diasCorridosParaAssinatura = void 0;
var diasCorridosParaAssinatura = 15;
exports.diasCorridosParaAssinatura = diasCorridosParaAssinatura;
var diasUteisParaAssinatura = 5;
exports.diasUteisParaAssinatura = diasUteisParaAssinatura;
var diasUteisParaAssinaturaContratoGeracaoDistribuida = 10;
exports.diasUteisParaAssinaturaContratoGeracaoDistribuida = diasUteisParaAssinaturaContratoGeracaoDistribuida;
